import React, { useState, useEffect } from "react";
import HeaderMiniso from "../Components/HeaderMiniso";
import FooterMiniso from "../Components/FooterMiniso";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import useUser from "../../../hooks/useUser";
import { useNavigate } from "react-router";
import axios from "axios";
import { proxyServer } from "../../../assets/constantes";

const initDataLogin = {
  user: "",
  password: "",
};
const LoginMonitor = () => {
  const [dataLogin, setDataLogin] = useState(initDataLogin);
  const [errorLogin, setErrorLogin] = useState("");
  const [
    a,
    b,
    c,
    d,
    e,
    f,
    g,
    monitorUser,
    setMonitorUser,
    setDataMonitorLocalStorage,
  ] = useUser();
  const navigate = useNavigate();
  useEffect(() => {
    if (monitorUser?.user !== "") {
      console.log("monitorUser is TRUE:..", monitorUser);
      if(monitorUser?.role === "admin"){
        navigate("/adminMonitor");
      }else if(monitorUser.paises.includes("MX")){
      navigate("/monitor");
      } else {
        navigate("/generalMonitor");
      }
      
    }
  }, [monitorUser]);
  const handleChange = (e) => {
    //console.log(e.target.name);
    //console.log(e.target.value);
    setDataLogin({
      ...dataLogin,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(dataLogin);
    try {

      const resultLogin = await axios.post(
        `${proxyServer}api/loginMonitorUser`,
        dataLogin
      );
      console.log("resultLogin:...", resultLogin);
      const statusResponse = resultLogin.status;
      console.log("statusResponse:...", statusResponse);
      if (statusResponse !== 200) {
        console.log("Error en el loginMonitorUser:..", resultLogin);
        const msgError = resultLogin.data.msg;
        setErrorLogin(msgError);
        return;
      }

      if(resultLogin?.data){
           //data.resultLogin
            const dataLoginResult = resultLogin.data?.resultLogin || {...initDataLogin};
            setDataMonitorLocalStorage({
              ...dataLoginResult,
            });
      }

      
      return;
    } catch (error) {
      console.log(error);
      const resultLogin = error.response;
      const statusResponse = resultLogin.status;
      console.log("statusResponse:...", statusResponse);
      if (statusResponse !== 200) {
        console.log("Error en el loginMonitorUser:..", resultLogin);
        const msgError = resultLogin.data.msg;
        setErrorLogin(msgError);
        return;
      }
    }
  };
  return (
    <div>
      <HeaderMiniso />
      <div style={{ height: "70vh" }}>
        <Form
          onSubmit={handleSubmit}
          className="card w-50 mt-5 me-auto ms-auto p-2 bg-secondary bg-opacity-50"
        >
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Usuario</Form.Label>
            <Form.Control
              name="user"
              onChange={handleChange}
              type="email"
              placeholder="Usuario"
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              name="password"
              onChange={handleChange}
              type="password"
              placeholder="Password"
            />
          </Form.Group>
          <Button
            className="w-50 ms-auto me-auto"
            variant="primary"
            type="submit"
          >
            Login
          </Button>
        </Form>
        {errorLogin !== "" && (
          <div className="alert alert-danger w-50 ms-auto me-auto mt-3">
            {errorLogin}
          </div>
        )}
      </div>
      <FooterMiniso />
    </div>
  );
};

export default LoginMonitor;
